module.exports = __webpack_public_path__ + "static/img/kogi-state.b6f2310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/kogi-state.png
// module id = 69Xw
// module chunks = 1